<div [ngStyle]="{ 'display' : terrainGridController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <div class="loading" [ngClass]="this.terrainGridController.loading? 'active' : ''">
    <div></div>
  </div>
  <form autocomplete="off"  id="ngTerrainGridForm" [ngClass]="[this.terrainGridController.active ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']" name="ngTerrainGridForm" #ngTerrainGridForm="ngForm" id="terrainGridForm" style="height: 600px">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Coordinates</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Latitude</label>
            <div class="coordenates">
              <select name="terrainCoordCardinal" style="width: 12%;" [(ngModel)]="terrainGridController.coordinates.latitude.cardinal"
                                                  (ngModelChange)="terrainGridController.latitude = terrainGridController.coordinates.toLat()">
                <option value="N">N</option>
                <option value="S">S</option>
              </select>
              <input name="terrainCoordDegrees" type="number" style="width: 25.5%;" [(ngModel)]="terrainGridController.coordinates.latitude.degrees"
                                                        (ngModelChange)="terrainGridController.latitude = terrainGridController.coordinates.toLat()" />
                <span>º</span>
              <input name="terrainCoordMinutes" type="number" style="width: 25.5%;" [(ngModel)]="terrainGridController.coordinates.latitude.minutes"
              (ngModelChange)="terrainGridController.latitude = terrainGridController.coordinates.toLat()"/>
                <span>´</span>
              <input name="terrainCoordSeconds" type="number" style="width: 25.5%;" [(ngModel)]="terrainGridController.coordinates.latitude.seconds"
              (ngModelChange)="terrainGridController.latitude = terrainGridController.coordinates.toLat()"/>
                <span>"</span>
                <br/>
              <input  name="terrainCoordSeconds2" type="number" style="width: 94.5%; margin-top: 10px;"
              [(ngModel)]="terrainGridController.latitude"
              (ngModelChange)="terrainGridController.coordinates.fromLat(terrainGridController.latitude)" name="terrainLat"
              />
                <span>º</span>
            </div>
          </div>
          <div>
            <label for="">Longitude</label>
            <div class="coordenates">
              <select name="terrainCoordCardLon" style="width: 12%;" [(ngModel)]="terrainGridController.coordinates.longitude.cardinal"
                                                                      (ngModelChange)="terrainGridController.longitude = terrainGridController.coordinates.toLon()" >
                <option value="W">W</option>
                <option value="E">E</option>
              </select>
              <input name="terrainCoordDegreesLon" type="text" style="width: 25.5%;" [(ngModel)]="terrainGridController.coordinates.longitude.degrees"
              (ngModelChange)="terrainGridController.longitude = terrainGridController.coordinates.toLon()"/>
                <span>º</span>
              <input name="terrainCoordMinutesLon" type="text" style="width: 25.5%;"  [(ngModel)]="terrainGridController.coordinates.longitude.minutes"
              (ngModelChange)="terrainGridController.longitude = terrainGridController.coordinates.toLon()"/>
                <span>´</span>
              <input name="terrainCoordSecondsLon" type="text" style="width: 25.5%;" [(ngModel)]="terrainGridController.coordinates.longitude.seconds"
              (ngModelChange)="terrainGridController.longitude = terrainGridController.coordinates.toLon()" />
                <span>"</span>
                <br/>
              <input type="number" style="width: 94.5%; margin-top: 10px;"
                name="terrainLon" [(ngModel)]="terrainGridController.longitude"
              (ngModelChange)="terrainGridController.coordinates.fromLon(terrainGridController.longitude)"/>
                <span>º</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Squares</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Number</label>
            <div class="coordenates"><input type="number" [(ngModel)]="terrainGridController.squareNumber" name="squareNumber" /></div>
          </div>
          <div>
            <div class="btn" (click)="terrainGridController.drawgrid()" style="padding: 10px 10px 10px 0;">
              <button>Draw Terrain Grid</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </form>
</div>
